// Maps dock urgency tone → Firefly expressive intent (V10).
// See docs/planning/firefly_visual_design.md color-extension §2.

import type { KpiTone } from "@/components/common/kpi/kpiTypes";
import type { FireflyIntent } from "./fireflyIntents";

export function resolveFireflyIntent(tone: KpiTone | null): FireflyIntent {
  switch (tone) {
    case "red":
      return "critical";
    case "amber":
      return "guidance";
    case "green":
      return "teaching";
    case "gold":
      return "teaching";
    default:
      // Ambient dock — no active urgency signal.
      return "focus";
  }
}
